import type { AnyComponentDoc, Tier } from './types'

const modules = import.meta.glob<{ default: AnyComponentDoc }>('./**/*.docs.tsx', { eager: true })

export const TIER_ORDER: Tier[] = ['atom', 'molecule', 'layout', 'pattern']

export const TIER_LABEL: Record<Tier, string> = {
  atom: 'Atoms',
  molecule: 'Molecules',
  layout: 'Layouts',
  pattern: 'Patterns',
}

export const COMPONENT_DOCS: AnyComponentDoc[] = Object.values(modules)
  .map((m) => m.default)
  .sort((a, b) => TIER_ORDER.indexOf(a.tier) - TIER_ORDER.indexOf(b.tier) || a.name.localeCompare(b.name))

export function findComponentDoc(slug: string): AnyComponentDoc | undefined {
  return COMPONENT_DOCS.find((doc) => doc.slug === slug)
}
